import { EntityModel } from '@/interfaces'
import {
  ALL_TESTIMONIALS_QUERY,
  CREATE_TESTIMONIAL_MUTATION,
  DELETE_TESTIMONIAL_MUTATION,
  FORCE_DELETE_TESTIMONIAL_MUTATION,
  SINGLE_TESTIMONIAL_QUERY,
  UPDATE_TESTIMONIAL_MUTATION,
} from './graphql'
import cmsTextWithIconBlockEntity from '@/entities/cmsTextWithIconBlock/entity'

const travelTestimonialModel: EntityModel = {
  name: 'testimonial',
  namePlural: 'testimonials',
  uniqueName: 'travelTestimonial',
  uniqueNamePlural: 'travelTestimonials',
  path: 'travel/testimonial',
  baseUrl: '/travel/testimonials',
  translationPrefix: 'entities:travelTestimonial.',
  getDisplayName: (values: any) => {
    return ''
  },
  gql: {
    getAll: ALL_TESTIMONIALS_QUERY,
    getSingle: SINGLE_TESTIMONIAL_QUERY,
    create: CREATE_TESTIMONIAL_MUTATION,
    update: UPDATE_TESTIMONIAL_MUTATION,
    delete: DELETE_TESTIMONIAL_MUTATION,
    forceDelete: FORCE_DELETE_TESTIMONIAL_MUTATION,
  },
  attributes: {
    contentBlock: {
      name: 'contentBlock',
      label: 'entities:travelTestimonial.attributes.contentBlock.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return cmsTextWithIconBlockEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default travelTestimonialModel
